import { globalEventBus } from '@fiverr-private/futile';
import { STATS } from '../helpers/eventName';
import { TYPES } from '../helpers/types';

const stats = TYPES.reduce(
    (accumulator, type) => Object.assign(
        accumulator,
        {

            /**
             * send a specific type stat (count, time, gauge...)
             * @param  {String}  prefix
             * @param  {String}  metric
             * @param  {Number}  [value=1]
             * @param  {Number}  [options.rate]
             * @param  {Object}  [options.tags] Tags in key/value pair
             * @param  {Boolean} [options.enforceRate]
             * @return {Promise}
             */
            [type]: (prefix, metric, value, { rate, tags, enforceRate } = {}) => {
                Object.entries({
                    prefix,
                    metric
                }).forEach(([name, value], index) => {
                    if (typeof value !== 'string' || !value) {
                        throw new TypeError(`Expected argument ${index} (${name}) to be a string. Instead got ${typeof value} (${value})`);
                    }
                });

                const key = [prefix, metric].join('.');

                return globalEventBus.deferred(
                    STATS,
                    { type, key, value, rate, tags, enforceRate }
                );
            }
        }
    ),
    {}
);

Object.defineProperty(
    stats,
    'prefix',
    {
        value: (prefix) => TYPES.reduce(
            (accumulator, type) => Object.assign(
                accumulator,
                { [type]: stats[type].bind(stats, prefix) }
            ),
            {}
        )
    }
);

export default stats;
